import React from 'react';
import { Button, Heading, Text, VStack } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="flex h-screen w-full items-center justify-center bg-body">
      <VStack spacing={6} textAlign="center" p={8}>
        <Heading size="4xl" color="text.tertiary">
          404
        </Heading>
        <Heading size="lg" color="text.tertiary">
          Página não encontrada
        </Heading>
        <Text color="text.secondary" maxW="md">
          A página que você está procurando não existe ou foi movida.
        </Text>
        <Button colorScheme="blue" onClick={() => navigate('/')} size="lg">
          Voltar para Home
        </Button>
      </VStack>
    </div>
  );
}
